import { useState } from "react";
import { Mail, ArrowLeft } from "lucide-react";
import { useAlert } from "../../hooks/useAlert";
import authService  from "../../services/auth.service";

export default function ForgotPassword() {
  const { showAlert } = useAlert();
  const [email, setEmail]     = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { showAlert({ type: "error", message: "Please enter your email." }); return; }
    setLoading(true);
    try {
      await authService.forgotPassword({ email });
      setSent(true);
    } catch (err) {
      showAlert({ type: "error", message: err.response?.data?.message ?? "Something went wrong." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-surface border border-border rounded-xl shadow-sm p-6">
          <a href="/login" className="flex items-center gap-1.5 text-xs text-text_muted hover:text-text_primary transition-colors mb-5">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to sign in
          </a>

          {sent ? (
            <div className="text-center py-4">
              <div className="w-12 h-12 rounded-full bg-success_bg flex items-center justify-center mx-auto mb-3">
                <Mail className="w-5 h-5 text-success" />
              </div>
              <h2 className="text-base font-semibold text-text_primary mb-1">Check your inbox</h2>
              <p className="text-sm text-text_muted">We sent a reset link to <strong>{email}</strong></p>
            </div>
          ) : (
            <>
              <h2 className="text-base font-semibold text-text_primary mb-1">Forgot password?</h2>
              <p className="text-sm text-text_muted mb-5">Enter your email and we'll send a reset link.</p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-xs font-medium text-text_secondary mb-1">Email address</label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text_muted pointer-events-none" />
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@suryagroup.us"
                      className="w-full pl-9 pr-4 py-2.5 text-sm rounded-lg bg-background border border-border text-text_primary placeholder:text-text_muted focus:outline-none focus:border-primary transition-colors"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-2.5 rounded-lg text-sm font-semibold text-white bg-primary hover:bg-primary_hover disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
                >
                  {loading ? "Sending…" : "Send reset link"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
